import { Component, EventEmitter, OnInit, Output, ElementRef, ViewChild, HostListener, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectLanguageData } from 'src/app/state/selectors'; // adjust path if needed
import { startWith } from 'rxjs';
import * as XLSX from 'xlsx';
import { DomSanitizer, SafeResourceUrl, SafeHtml } from '@angular/platform-browser';
import { Editor } from 'ngx-editor';
import { Toolbar } from 'ngx-editor';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { RxFormBuilder, RxwebValidators } from '@rxweb/reactive-form-validators';
import { FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { PricingMatrixHelper } from '../../../utils/pricing-matrix.helper';
import { capitalizeFirst, toLowerCase } from 'src/utils/string-utils';
import Quill from 'quill';
import * as ValidationUtils from 'src/utils/supplier-validation.utils';

// Register custom font sizes
const Size = Quill.import('attributors/style/size')
Size.whitelist = ['12px', '14px', '16px', '18px', '20px', '22px', '24px'];
Quill.register(Size, true);

@Component({
  selector: 'app-create-supplier',
  templateUrl: './create-supplier.component.html',
  styleUrls: ['./create-supplier.component.css']
})
export class CreateSupplierComponent implements OnInit {
  @Output() onClose = new EventEmitter<void>();

  // @Input() refreshParentData!: () => void;
  @Output() refreshParentDataForCreateSupplier = new EventEmitter<void>();

  @ViewChild('pdfCanvas') pdfCanvasRef!: ElementRef<HTMLCanvasElement>;
  constructor(private store: Store<{ languageData: [] }>, private domSanitizer: DomSanitizer, private sanitizer: DomSanitizer, private formBuilder: RxFormBuilder, private http: HttpClient, private router: Router, private route: ActivatedRoute) {
    this.languageData$ = store.select(selectLanguageData);
  }

  closeComponent() {
    // window.location.reload()
    console.log("called child component off**********************")
    this.router.navigate(['/supplier']);
    //  this.refreshParentDataForCreateSupplier.emit(); 
    // this.onClose.emit();
  }

  // *****************************Supplier Name List********************************
  supplierExists = false;

  matchedSupplierName: string = null;
  existingSuppliers: any = []
  onSupplierInput(value: string) {
    this.validateField('supplierName', value)
    this.supplierName = value;
    const trimmedValue = value.trim().toLowerCase();

    if (!trimmedValue) {
      this.matchedSupplierName = null;
      return;
    }

    const match = this.existingSuppliers.find(supplier =>
      supplier.name.toLowerCase().startsWith(trimmedValue)
    );

    this.matchedSupplierName = match ? match.name : null;
  }

  // *********************************VALIDATION FOR CONTACT FORM*****************************//
  contactForm!: FormGroup;
  submitted = false;
  onRoleChangeOfContactInfo(event: any) {
    const roleValue = event.target.value;
    this.showOther = roleValue === 'Other';

    const otherControl = this.contactForm.get('contact_other');
    if (this.showOther) {
      otherControl?.setValidators(RxwebValidators['required']());
    } else {
      otherControl?.clearValidators();
      otherControl?.setValue('');
      this.contact_other = '';
    }
    otherControl?.updateValueAndValidity();
  }




  // ************ Provinces ***********************//
  // country setting
  countries = [
    { id: 1, name: 'Canada' },
    { id: 2, name: 'USA' }];

  currencies = [
    { id: 1, name: 'CAD' },
    { id: 2, name: 'USD' }];
  productIdentifier = [
    { id: 1, name: 'Mental Health & Wellbeing' },
    { id: 2, name: 'Health & Dental' },
    { id: 3, name: 'Life & Disability Protection' },
    { id: 4, name: 'Private Health' },
    { id: 5, name: 'Other' }
  ];


  // it is common for country and product identifier
  countryDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'name',
    allowSearchFilter: false,
    closeDropDownOnSelection: true
  };


  showOtherInput: boolean = false;
  showOtherInputForBaseUnit: boolean = false;

  otherInputForProductIdentiFier: string = null;
  otherInputForBaseUnit: string = null;

  onSelectProductIdentityFier(item: any): void {
    console.log("onSelectProductIdentityFier :", item);
    this.showOtherInput = item.name === 'Other';
  }

  onDeselectProductIdentityFier(item: any): void {
    if (item.name === 'Other') {
      this.showOtherInput = false;
      this.otherInputForProductIdentiFier = '';
    }
  }
  onSelectBaseUnit(item: any): void {
    console.log("onSelectProductIdentityFier :", item);
    this.showOtherInputForBaseUnit = item.value === 'Other';
  }

  onDeselectonBaseUnit(item: any): void {
    if (item.value === 'Other') {
      this.showOtherInputForBaseUnit = false;
      this.otherInputForBaseUnit = '';
    }
  }
  formatCurrency(event: any) {
    let value: string = event.target.value;

    // Always keep $ at the start
    if (!value.startsWith('$')) {
      value = '$' + value.replace(/\$/g, '');
    }

    // Remove everything except numbers and .
    value = '$' + value.slice(1).replace(/[^0-9.]/g, '');

    // Allow only one "."
    const parts = value.slice(1).split('.');
    if (parts.length > 2) {
      value = '$' + parts[0] + '.' + parts.slice(1).join('');
    }

    event.target.value = value;
    this.otherInputForBaseUnit = value;
  }

  ensureDollar(event: any) {
    let value: string = event.target.value;
    if (value.trim() === '' || value === '$') {
      event.target.value = '$';
      this.otherInputForBaseUnit = '$';
    }
  }

  // provinces: any[] = [];
  provinces = [
    { id: 1, name: 'Alberta', shortName: 'AB' },
    { id: 2, name: 'British Columbia', shortName: 'BC' },
    { id: 3, name: 'Manitoba', shortName: 'MB' },
    { id: 4, name: 'New Brunswick', shortName: 'NB' },
    { id: 5, name: 'Newfoundland and Labrador', shortName: 'NL' },
    { id: 6, name: 'Nova Scotia', shortName: 'NS' },
    { id: 7, name: 'Ontario', shortName: 'ON' },
    { id: 8, name: 'Prince Edward Island', shortName: 'PE' },
    { id: 9, name: 'Quebec', shortName: 'QC' },
    { id: 10, name: 'Saskatchewan', shortName: 'SK' },
    { id: 11, name: 'Northwest Territories', shortName: 'NT' },
    { id: 12, name: 'Nunavut', shortName: 'NU' },
    { id: 13, name: 'Yukon', shortName: 'YT' }
  ];


  selectedProvinces: any[] = [];

  filteredProvinces: any[] = [];

  dropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'shortName',
    itemsShowLimit: 2,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    enableCheckAll: true,
    allowSearchFilter: true,
  };
  vendorAddressSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'shortName',
    allowSearchFilter: true,
  };

  onItemSelect(item: any) {
    this.updateFilteredProvinces();
    console.log('Selected:', item);
    console.log("selected zz:", this.selectedProvinces);
  }


  onSelectAll(items: any) {
    console.log('All Selected:', items);
    this.updateFilteredProvinces();
    this.filteredProvinces = [...items];
  }


  onDeSelectAll(items: any) {
    this.filteredProvinces = [];
  }

  onItemDeSelect(item: any) {
    this.updateFilteredProvinces();
  }
  //here we are filtering provinces to show in pricing area section dropdown
  updateFilteredProvinces() {
    this.filteredProvinces = this.selectedProvinces;
  }




  //----------**** STRING MULTI LANGUAGE*******-------------
  lang: any = {};
  languageData$: any;
  selectedLanguage: string;

  public getLanguageTokens() {
    this.languageData$ = this.store.select(state => state.languageData).pipe(startWith([]));

    this.languageData$.subscribe(data => {
      if (!data || !data.languageData || Object.keys(data.languageData).length === 0) {
        console.log('No language data found');
        return;
      }

      setTimeout(() => {
        this.lang = {};
        this.selectedLanguage = sessionStorage.getItem("language") || 'english';
        for (let token of data.languageData) {
          this.lang[token.key] = token[this.selectedLanguage];
        }
      }, 0);
    });
  }

  //----------****Supplier Auto ID Generated*******-------------
  supplierID: string = ''
  generateSupplierID(): string {
    const randomLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
    const randomNumber = Math.floor(1000000000 + Math.random() * 9000000000);
    return `${randomLetter}-${randomNumber}`;
  }

  //----------****CONTACT INFORMATION SECTION*******-------------
  supplierName: string = '';
  firstName: string = '';
  emailReports: boolean = false;
  lastName: string = '';
  email: string = '';
  phone: string = '';
  role: string = '';
  contact_other: string = '';

  showOther: boolean = false;

  selectedIndex: Number = null;

  showContactModal: boolean = false;
  showProductModal: boolean = false;

  showContactEditModal: boolean = false;
  showDeleteConfirm: boolean = false;
  contacts: any[] = [];

  //roles
  roles: string[] = [
    'Accountant',
    'Key Account Manager',
    'Product Manager',
    'Underwriter',
    'Other'
  ];
  //save contact
  onSaveContact() {
    this.submitted = true;
    const contact = {
      firstName: capitalizeFirst(this.firstName),
      lastName: capitalizeFirst(this.lastName),
      email: toLowerCase(this.email),
      emailReports: this.emailReports,
      phone: this.phone,
      role: this.contact_other.length > 0 ? this.contact_other : capitalizeFirst(this.role)
    };
    if (this.contactForm.valid) {
      this.contacts.push(contact);
      this.firstName = '';
      this.lastName = '';
      this.email = '';
      this.emailReports = false;
      this.phone = '';
      this.role = '';
      this.showOther = false
      this.showContactModal = false;
      console.log("Saved contact:", contact);
      console.log('Form Submitted', this.contactForm.value);
      // Reset form state
      this.contactForm.reset();
      this.submitted = false;
    } else {
      console.log("Please fill all contact information :", this.contactForm.value)
    }
  }

  // formatPhoneNumber() {
  //   // Keep only numbers
  //   let digitsOnly = this.phone.replace(/\D/g, '');

  //   // Limit to exactly 11 digits
  //   if (digitsOnly.length > 10) {
  //     digitsOnly = digitsOnly.substring(0, 10);
  //   }

  //   // If not 11 yet, don't format
  //   if (digitsOnly.length < 10) {
  //     this.phone = digitsOnly;
  //     return;
  //   }

  //   // Format to: +1 (555) 555-1212
  //   this.phone = `+1 (${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6, 10)}`
  // }
  formatPhoneNumber(raw: string): string {
    const cleaned = raw.replace(/\D/g, '');

    if (cleaned.length >= 10) {
      const area = cleaned.slice(-10, -7);
      const prefix = cleaned.slice(-7, -4);
      const line = cleaned.slice(-4);
      return `+1 (${area}) ${prefix}-${line}`;
    }

    return raw;
  }


  // show other
  onRoleChange(event: any) {
    const selectedValue = event.target.value;
    this.showOther = selectedValue === 'Other';

    const otherControl = this.contactForm.get('contact_other');

    if (this.showOther) {
      // Apply required validator
      otherControl?.setValidators(RxwebValidators['required']());
    } else {
      // Remove validator and clear value
      otherControl?.clearValidators();
      otherControl?.setValue('');
      this.contact_other = '';
    }

    otherControl?.updateValueAndValidity();
  }

  // update contact
  editSupplier(index: number) {
    this.showContactEditModal = true;
    const selectedContact = this.contacts[index];
    console.log("selectedContact :", selectedContact);
    this.firstName = selectedContact.firstName;
    this.lastName = selectedContact.lastName;
    this.email = selectedContact.email;
    this.emailReports = selectedContact.emailReports,
      this.phone = selectedContact.phone;

    this.role = (selectedContact.role === "Accountant" || selectedContact.role === "Key Account Manager" || selectedContact.role === "Product Manager" || selectedContact.role === "Underwriter") ? selectedContact.role : 'Other'
    this.selectedIndex = index
    if (this.role === "Other") {
      this.contact_other = selectedContact.role;
      this.showOther = true;
    }

  }
  //for updating contact
  onUpdateContact(index: number) {
    this.submitted = true;

    if (this.contactForm.invalid) {
      return; // Stop if validation fails
    }

    this.contacts[index] = {
      firstName: capitalizeFirst(this.firstName),
      lastName: capitalizeFirst(this.lastName),
      email: toLowerCase(this.email),
      emailReports: this.emailReports,
      phone: this.phone,
      role: this.role === 'Other' ? this.contact_other : capitalizeFirst(this.role)
    };



    // Reset form and state
    this.showContactEditModal = false;
    this.firstName = '';
    this.lastName = '';
    this.email = '';
    this.emailReports = false;
    this.phone = '';
    this.role = '';
    this.contact_other = '';
    this.showOther = false;
    this.submitted = false;

    this.contactForm.reset(); // Reset reactive form too
  }

  // close update contact popup
  onCloseEditPopup() {
    this.firstName = '';
    this.lastName = '';
    this.email = '';
    this.emailReports = false;
    this.phone = '';
    this.role = ''
    this.contact_other = ''
    this.showOther = false;


    this.showContactEditModal = false;
    this.showContactModal = false;
    this.contactForm.reset();
    this.submitted = false;
  }


  // delete contact 
  indexNumberForDelete: Number = null;
  selectedContact = {
    name: '',
    role: ''
  };

  deleteContact(contact: any, index: number) {
    this.selectedContact.name = contact.firstName + " " + contact.lastName;
    this.selectedContact.role = contact.role;
    this.indexNumberForDelete = index;
    this.showDeleteConfirm = true;
  }
  onConfirmDelete(index: number) {
    this.contacts.splice(index, 1);
    this.showDeleteConfirm = false;
  }
  onCancelDelete() {
    this.indexNumberForDelete = null;
    this.showDeleteConfirm = false;
  }
  allowOnlyNumbers(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'
    ];

    if (allowedKeys.includes(event.key)) {
      return;
    }

    const isDigit = /^[0-9]$/.test(event.key);
    if (!isDigit) {
      event.preventDefault(); // Block anything that's not a digit
    }
  }

  allowOnlyNumbersForPhoneNumber(event: KeyboardEvent, inputValue: string) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'];

    // Allow control keys
    if (allowedKeys.includes(event.key)) {
      return;
    }

    // Prevent if not a number
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }

    // Prevent if already 11 digits
    if (inputValue.length >= 10) {
      event.preventDefault();
    }
  }

  //----------****SERVICE LEVEL SECTION*******-------------


  age_: boolean = false;
  minAge: number | null = null;
  maxAge: number | null = null;
  childAgeOut: number | null = null;
  studentAgeOut: number | null = null;


  //----------**** Add Product *******-------------
  products: any[] = [];
  product_ID: string = "";
  product_name: string = "";
  product_indetifier: any[] = [];
  referenceID: string = "";
  product_country = [{ id: 1, name: 'Canada' }];
  effective_Distribution_Date: string = new Date().toISOString().split('T')[0];
  renewalDate: Date = null;
  selectedFileName: string = '';
  selectedBooklet: string = '';
  isCOB: boolean = false;
  billingType: string = "";
  paymentOption: string = "";
  expected_Payment_Date: Date = null;
  bank_code: Number = null;
  transit: Number = null;
  account_number: Number = null;

  ageError: string = '';

  validateAgeRange() {
    if (this.minAge != null && this.maxAge != null) {
      const min = Number(this.minAge);
      const max = Number(this.maxAge);

      // Must be numbers
      if (isNaN(min) || isNaN(max)) {
        this.ageError = 'Ages must be numbers';
        return false;
      }

      // Min age check
      if (min < 18) {
        this.ageError = 'Minimum Age must be at least 18';
        return false;
      }

      // Max age check
      if (max > 70) {
        this.ageError = 'Maximum Age cannot be greater than 70';
        return false;
      }

      // Logical relation
      if (max <= min) {
        this.ageError = 'Max Age must be greater than Min Age';
        return false;
      }

      this.ageError = '';
      return true;
    }

    this.ageError = '';
    return true;
  }


  resetAgeFields(): void {
    this.minAge = null;
    this.maxAge = null;
    this.studentAgeOut = null;
    this.childAgeOut = null;
    this.ageError = null;
  }

  onBillingTypeChange() {
    this.paymentOption = "PAD From GB";
  }

  //it is validation for showing Service Section 
  get isProductValidForFirstRow(): boolean {
    const data = (
      this.product_ID.trim() !== '' &&
        this.product_name.length > 0 &&
        this.effective_Distribution_Date !== null &&
        this.productIdentifier &&
        this.product_country[0].name.trim() !== '' &&
        this.product_indetifier &&
        this.selectedProvinces.length > 0 &&
        this.renewalDate ? true : false
    )
    return data;
  }
  //it is validation for showing Prodct Details
  get isProductValidForSecondRow(): boolean {
    const data = (
      this.age_ && this.minAge && this.maxAge &&
      this.isCOB
    )
    return true
  }

  //it is validation for showing Pricing Section
  get isProductValidForThirdRow(): boolean {
    const data = (
      this.savedContent && this.savedProductResourceContent && this.bookletFiles.length
    ) ? true : false;
    return true
  }

  // it is validation for showing vendor and pricing 
  get isProductValidForVendorAndPricing(): boolean {
    let billing = false;
    if (this.billingType === 'self-billing') {
      billing = !!(this.bank_code && this.transit && this.account_number);
    } else if (this.billingType === 'invoiced') {
      if (this.paymentOption === 'EFT to Vendor') {
        billing = !!(this.bank_code && this.transit && this.account_number);
      } else if (this.paymentOption === 'PAD From GB') {
        billing = this.expected_Payment_Date ? true : false
      }
    }
    // return billing;
    return true
  }

  // it is validation for Pricing section
  get isPricingSection(): boolean {
    // return this.selectedBaseUnit && this.taxApplicable
    return true
  }

  onSaveProduct() {
    console.log("table price:", this.pricingMatrix)
    this.tieredRows = this.tieredRows.map((item, index) => ({
      ...item,
      id: index + 1
    }))
    this.ageBands = this.ageBands.map((item, index) => ({
      ...item,
      id: index + 1
    }))
    this.variantRows = this.variantRows.map((item, index) => ({
      ...item,
      id: index + 1
    }))
    this.categoryRows = this.categoryRows.map((item, index) => ({
      ...item,
      id: index + 1
    }))

    const flatFields = this.rows.flatMap(row => row.fields).map((item, index) => ({
      ...item,
      id: index + 1
    }));


    const data = {
      version: 'v1.0',
      productInfo: {
        productId: this.product_ID,
        productName: this.product_name.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
        effectiveDistributionDate: this.effective_Distribution_Date,
        productCountry: this.product_country,
        selectedProvinces: this.selectedProvinces,
        productIdentifier: this.product_indetifier,
        showOtherInputForProductIdentifier: this.showOtherInput,
        productNewInputIdentifier: this.otherInputForProductIdentiFier,
        renewalDate: this.renewalDate
      },
      limits: {
        isCOB: this.isCOB,
        isAgeLimitEnabled: this.age_,
        minAge: this.minAge,
        maxAge: this.maxAge,
        childAgeOut: this.childAgeOut,
        studentAgeOut: this.studentAgeOut
      },
      productDetails: {
        bookletFile: this.bookletFiles,
        productResourceContent: this.productResourceSavedContent,
        productResourceHTML: this.safeHtmlContentForProduct_Resource,
        tileDescriptionContent: this.tileDescriptionSavedContent,
        tileDescriptionHTML: this.safeHtmlContent,
        tileLogo: this.previewTileLogoUrl,
        bookletFileName: this.bookletFileName,
        productResourceFileName: this.selectedFileName,
        tileFileName: this.tileFileName,
        billingType: this.billingType,
        paymentOption: this.paymentOption,
        bandCode: this.bank_code,
        transit: this.transit,
        accountNumber: this.account_number,
        expectedPaymentDate: this.expected_Payment_Date,
        getHealthCardsPayload: this.getHealthCardsPayload()
      },
      vendorInvoicingAndPaymentMethod: {
        billingType: this.billingType,
        paymentOption: this.paymentOption,
        eftToVendor: {
          bankCode: this.bank_code,
          transit: this.transit,
          accountNumber: this.account_number
        },
        expectedPaymentDate: this.expected_Payment_Date
      },
      pricing: {
        isBaseAmountApplicable: this.isBaseAmount,
        baseAmount: this.selectedBaseUnit,
        isPriceInclusiveOfTax: this.inclusiveTax,
        isTaxApplicable: this.taxApplicable,
        showOtherInputForBaseUnit: this.showOtherInputForBaseUnit,
        otherInputForBaseUnit: this.otherInputForBaseUnit,
        taxTypes: this.taxTypes,
        advisorCommission: this.advisorCommission,
        tpaCommission: this.tpaCommission,
        otherFees: this.otherFees,
        unitPrice: this.unitPrice,
        advisorCommissionType: this.advisorCommissionType,
        tpaCommissionType: this.tpaCommissionType,
        otherFeesType: this.otherFeesType,
        unitPriceType: this.unitPriceType,
        showPricingTable: this.showPricingTable,
        showTableType: this.showTableType
      },
      areas: {
        noOfAreas: this.noOfPricingAreas,
        areasData: this.pricingAreaRows
      },
      tiers: {
        isTierEnabled: this.isTiered,
        noOfTiers: this.noOfTiered,
        tiersData: this.tieredRows
      },
      ageBands: {
        isAgeBandEnabled: this.isAgeBanded,
        noOfAgeBands: this.noOfAgeBands,
        ageBandsData: this.ageBands
      },
      variants: {
        isVariantEnabled: this.isVariantEnabled,
        noOfVariants: this.noOfVariants,
        variantsData: this.variantRows
      },
      serviceLevel: {
        isServiceLevelEnabled: this.isCategory,
        noOfServiceLevel: this.noOfCategories,
        servicesData: this.categoryRows
      },
      pricingMatrix: this.pricingMatrix,
      signUpData: this.getSignupPayload(),
      provisioningAndReporting: this.getPayload()
    };

    this.products.push(data);
    this.showProductModal = false;

    console.log("Saved Product:", this.products);
  }

  // show excel table for tile description
  // excelData: any[][] = [];

  //handle booklet description file
  bookletData: any[][] = [];
  showBookletPopup: boolean = false;
  previewHtml: SafeHtml | null = null;
  showPopupForBookletChooseFile: boolean = false;
  selectedBookletChooseFileName: string = "";

  // onBookletFileChange(event: any) {
  //   const target: DataTransfer = <DataTransfer>event.target;
  //   if (target.files.length !== 1) return;
  //   const file: File = target.files[0];
  //   this.selectedBooklet = file.name;
  //   const reader: FileReader = new FileReader();

  //   reader.onload = (e: any) => {
  //     const bstr: string = e.target.result;
  //     const workbook: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
  //     const sheetName: string = workbook.SheetNames[0];
  //     const worksheet: XLSX.WorkSheet = workbook.Sheets[sheetName];
  //     const data = <any[][]>XLSX.utils.sheet_to_json(worksheet, { header: 1 });
  //     this.bookletData = data;
  //   };

  //   reader.readAsBinaryString(file);
  // }

  pdfBase64Data: string | null = null;

  // onFileSelecteds(event: any) {
  //   const file: File = event.target.files[0];
  //   if (!file) return;

  //   this.selectedBookletChooseFileName = file.name;
  //   const reader = new FileReader();
  //   reader.onload = () => {
  //     const binaryData = reader.result as ArrayBuffer;

  //     const rtfContent = reader.result as string;

  //     const html = this.convertRtfToHtml(rtfContent);

  //     this.previewHtml = this.sanitizer.bypassSecurityTrustHtml(html);

  //   };

  //   reader.readAsText(file);
  //   this.showPopupForBookletChooseFile = true;
  // }

  // convertRtfToHtml(rtf: string): string {
  //   return rtf
  //     .replace(/\\par[d]?/g, '<br>')
  //     .replace(/{\\[^}]+}/g, '')
  //     .replace(/\\'[0-9a-fA-F]{2}/g, '')
  //     .replace(/\\[^ ]+ ?/g, '')
  //     .replace(/{|}/g, '');
  // }

  // generate ProductID
  generateProductID(): string {
    const randomLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
    const randomNumber = Math.floor(10000 + Math.random() * 90000);
    return `${randomLetter}-${randomNumber}`;
  }


  onProductModel() {
    this.showProductModal = true;
    this.product_ID = this.generateProductID()
  }


  // For Tile Description File
  tileFileName: string = '';
  tileTextContent: string | null = null;
  tileExcelData: any[][] = [];
  tileSafeUrl: SafeResourceUrl | null = null;
  tilePreviewType: 'text' | 'excel' | 'pdf' | 'doc' | 'unsupported' | null = null;

  previewTileLogoUrl: string | ArrayBuffer | null = null;
  handleTileLogo(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];
    console.log("got tile file:", file);

    const reader = new FileReader();
    reader.onload = () => {
      this.previewTileLogoUrl = reader.result as string;
    };
    reader.readAsDataURL(file);
  }


  // For Booklet File
  bookletFileName: string = '';
  bookletTextContent: string | null = null;
  bookletExcelData: any[][] = [];
  bookletSafeUrl: SafeResourceUrl | null = null;
  bookletPreviewType: 'text' | 'excel' | 'pdf' | 'doc' | 'unsupported' | null = null;

  // handleBoookletFile(event: any): void {
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   this.bookletFileName = file.name;
  //   const ext = file.name.split('.').pop()?.toLowerCase();
  //   const reader = new FileReader();

  //   if (['txt', 'csv', 'json', 'xml', 'html', 'doc', 'docx'].includes(ext!)) {
  //     reader.onload = () => {
  //       this.pdfBase64Data = (reader.result as string).split(',')[1];
  //       this.tilePreviewType = 'text';
  //       this.tileTextContent = reader.result as string;
  //     };
  //     reader.readAsText(file);
  //   } else if (ext === 'pdf') {
  //     reader.onload = () => {
  //       this.pdfBase64Data = (reader.result as string).split(',')[1];
  //       this.tilePreviewType = 'pdf';
  //       this.tileSafeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(reader.result as string);
  //     };
  //     reader.readAsDataURL(file);
  //   } else {
  //     this.tilePreviewType = 'unsupported';
  //   }
  // }

  // **************************** Handle Tookit *****************************
  selectedFiles: { file: File, url: SafeResourceUrl, name: string }[] = [];
  showPopup = false;
  showPopupPdf = false;
  showToolkitPDF = false;
  showPdfViewerPopup = false;
  currentPdfUrl: SafeResourceUrl | null = null;
  bookletFiles: { name: string, base64Data: string }[] = [];

  handleBookletFile(event: any) {
    const files: FileList = event.target.files;

    if (this.selectedFiles.length >= 5) {
      alert('You can upload a maximum of 5 PDF files.');
      event.target.value = '';
      return;
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (file.type === 'application/pdf') {
        if (this.selectedFiles.length < 5) {
          const fileUrl = URL.createObjectURL(file);
          const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fileUrl);

          this.selectedFiles.push({
            file: file,
            url: safeUrl,
            name: file.name
          });

          const reader = new FileReader();
          reader.onload = () => {
            const base64Data = (reader.result as string).split(',')[1];
            this.bookletFiles.push({
              name: file.name,
              base64Data: base64Data
            });
          };
          reader.readAsDataURL(file);
        } else {
          alert('Maximum 5 PDFs allowed. Extra files were ignored.');
          break;
        }
      }
    }

    event.target.value = '';
  }

  currentPDFName: string = "";
  viewPdf(pdfUrl: SafeResourceUrl, name: string) {
    this.currentPdfUrl = pdfUrl;
    this.currentPDFName = name;
    this.showToolkitPDF = true
  }


  closePopup() {
    this.showPopup = false;
    this.currentPdfUrl = null;
  }

  deletePdf(index: number) {
    this.selectedFiles.splice(index, 1);
    if (this.selectedFiles.length === 0) {
      this.showPopup = false
    }
  }
  // **************************** End Toolkit ****************************************

  product_resource_editor!: Editor;
  product_resource_html = '';
  saved_product_resource_info: string | null = null;
  show_product_resource_editor: boolean = false;
  show_product_resource_preview: boolean = false;
  safe_product_resource_html: SafeHtml;

  onProductResourceInfoCreate() {
    this.show_product_resource_editor = true;
    this.product_resource_html = this.saved_product_resource_info || '';
  }

  // Save Product Resource Info
  onProductResourceInfoSave(): void {
    this.saved_product_resource_info = this.product_resource_html;
    this.safe_product_resource_html = this.sanitizer.bypassSecurityTrustHtml(
      this.product_resource_html
    );
    this.show_product_resource_editor = false;
  }

  // onProductResourceInfoKeyDown(event: KeyboardEvent): void {
  //   // If only Enter is pressed (not Shift+Enter), simulate Shift+Enter behavior
  //   if (event.key === 'Enter' && !event.shiftKey) {
  //     event.preventDefault(); // prevent default behavior

  //     const selection = window.getSelection();
  //     if (!selection || selection.rangeCount === 0) return;

  //     const range = selection.getRangeAt(0);

  //     // insert a <br> tag
  //     const br = document.createElement('br');
  //     range.insertNode(br);

  //     // Optional: Add second <br> for paragraph spacing
  //     // range.insertNode(document.createElement('br'));

  //     // Move cursor after the <br>
  //     range.setStartAfter(br);
  //     range.setEndAfter(br);

  //     selection.removeAllRanges();
  //     selection.addRange(range);
  //   }
  // }



  // *****************************ngx-editor******************************************* //

  // toolbar: Toolbar = [
  //   ['bold', 'italic', 'underline'],
  //   ['strike', 'code', 'blockquote'],
  //   ['ordered_list', 'bullet_list'],
  //   [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
  //   ['link', 'image'],
  //   ['text_color', 'background_color'],
  //   ['align_left', 'align_center', 'align_right', 'align_justify'],
  // ];

  editor!: Editor;
  html = '';
  showEditor = false;
  savedContent = '';
  savedProductResourceContent = '';
  previewContent: boolean = false;
  showBookletPreview: boolean = false;
  safeHtml: SafeHtml;

  tileError: boolean = false;
  onTileFileSave(): void {
    // Store the editor content for preview
    if (!this.editorContent || !this.previewTileLogoUrl) {
      this.tileError = true;
      return;
    }
    this.tileDescriptionSavedContent = this.editorContent
    this.savedContent = this.tileDescriptionSavedContent

    this.safeHtmlContent = this.sanitizer.bypassSecurityTrustHtml(this.tileDescriptionSavedContent);
    this.showTileQuillEditor = false;
    // this.editorContent = null;
  }
  productResourceSavedContent: string = '';
  tileDescriptionSavedContent: string = '';


  onProductResourceFileSave(): void {
    // Store the editor content for preview
    this.productResourceSavedContent = this.editorContentForProductResource
    this.savedProductResourceContent = this.productResourceSavedContent;
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.html);
    this.safeHtmlContentForProduct_Resource = this.sanitizer.bypassSecurityTrustHtml(this.editorContentForProductResource);

    this.showProduct_Resource_QuillEditor = false;
    // this.editorContent = null;
  }
  onCanceloOfTileDescription(): void {
    this.showTileQuillEditor = false
    this.editorContent = null;
  }
  onCanceloOfProductResourceDescription(): void {
    this.showProduct_Resource_QuillEditor = false
    // this.editorContentForProductResource = null;
  }
  // Pricing Section// ****************Pricing Area***************//

  isBaseAmount: boolean = false;
  taxApplicable: boolean = false;
  taxTypes = {
    hst: false,
    pst: false
  };

  inclusiveTax: boolean = false;

  ageBanded: boolean = false;
  ageBandCount: number | null = null;
  pricingAreaRows: any[] = [
    {
      area: 1,
      name: '',
      selectedProvinces: []
    }
  ];


  noOfPricingAreas: number | null = 1;

  //pricing provinces setting
  pricingProvincesdropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'shortName',
    itemsShowLimit: 1,
    allowSearchFilter: true,
    enableCheckAll: true,
    closeDropDownOnSelection: false
  };
  //increase table rows 
  generatePricingAreaRows(count: number) {
    this.pricingAreaRows = [];
    for (let i = 0; i < count; i++) {
      this.pricingAreaRows.push({
        area: i + 1,
        name: '',
        selectedProvinces: []
      });
    }
  }

  // Filtered list per row
  getAvailableProvinces(index: number) {
    const selectedInOthers = this.pricingAreaRows
      .filter((_, i) => i !== index)
      .flatMap(r => r.selectedProvinces.map(p => p.id));

    return this.filteredProvinces.filter(
      p => !selectedInOthers.includes(p.id)
    );
  }

  // Selection & De-Selection Logic
  onPricingProvinceSelect(event: any, index: number) {
    const fullProvince = this.provinces.find(p => p.id === event.id);
    if (fullProvince) {
      const alreadyAdded = this.pricingAreaRows[index].selectedProvinces.some(p => p.id === fullProvince.id);
      if (!alreadyAdded) {
        this.pricingAreaRows[index].selectedProvinces.push(fullProvince);
      }
    }
  }

  onSelectAllPricingProvinces(events: any[], index: number) {
    const fullObjects = events
      .map(ev => this.provinces.find(p => p.id === ev.id))
      .filter(p => !!p); // remove undefined

    this.pricingAreaRows[index].selectedProvinces = fullObjects;
  }

  onPricingProvinceDeSelect(event: any, index: number) {
    this.pricingAreaRows[index].selectedProvinces =
      this.pricingAreaRows[index].selectedProvinces.filter(
        p => p.id !== event.id
      );
  }

  onDeSelectAllPricingProvinces(event: any, index: number) {
    this.pricingAreaRows[index].selectedProvinces = [];
  }




  // ****************Pricing Areas and Age Banding*****************//
  noOfVariants: number = null;
  noOfAgeBands: number = null;
  isAgeBanded: boolean = false;
  isVariantEnabled: boolean = false;
  selectedBaseUnit: any = null;

  onAgeBandChange(value: boolean): void {
    this.isAgeBanded = value;
    if (value) {
      this.isTiered = false;
      this.noOfTiered = null
      this.tieredRows = [];
    } else {
      this.ageBands = [];
      this.noOfAgeBands = null;
    }
  }
  onTierChange(value: boolean): void {
    this.isTiered = value;

    if (value) {
      this.isAgeBanded = false;
      this.noOfAgeBands = null;
      this.ageBands = [];
    } else {
      this.tieredRows = [];
      this.noOfTiered = null;
    }
  }
  onVarientChange(value: boolean): void {
    this.isVariantEnabled = value;
    this.noOfVariants = null;
    this.variantRows = [];
  }
  onServiceLevelChange(value: boolean): void {
    this.isCategory = value;
    this.noOfCategories = null;
    this.categoryRows = [];
  }
  baseUnitValues = [
    { id: 1, value: '$1' },
    { id: 2, value: '$100' },
    { id: 3, value: '$1000' },
    { id: 4, value: '$10000' },
    { id: 5, value: '$100000' },
    { id: 6, value: '$1000000' },
    { id: 7, value: 'Other' },
  ];





  ageBands: any[] = [];
  ageBandErrors: { start: boolean; end: boolean }[] = [];
  variantRows: any[] = []

  generateAgeBands(count: number) {
    this.ageBands = [];
    for (let i = 0; i < count; i++) {
      this.ageBands.push({
        start: null,
        end: null,
      });
    }
    this.noOfAgeBands = count;
  }

  // This updates next row's start when current row's end changes
  onEndChange(index: number): void {
    const currentEnd = this.ageBands[index].end;
    if (index + 1 < this.ageBands.length) {
      this.ageBands[index + 1].start = currentEnd;
    }
  }

  generateVariants(count: number) {
    this.variantRows = [];
    for (let i = 0; i < count; i++) {
      this.variantRows.push({
        name: '',
      });
    }
  }

  // ****************Tiered and Categories*****************//
  isTiered: boolean = false;
  noOfTiered: number = null;
  tieredRows: { name: string }[] = [];

  isCategory: boolean = false;
  noOfCategories: number = null;
  categoryRows: { name: string }[] = [];


  generateTieredRows(count: number) {
    this.tieredRows = Array.from({ length: count }, () => ({ name: '' }));
    if (this.noOfTiered <= 0) {
      this.isTiered = false;
      this.noOfTiered = null;
    } else {
      this.isTiered = true;
    }
  }

  generateCategoryRows(count: number) {
    this.categoryRows = Array.from({ length: count }, () => ({ name: '' }));
    if (this.noOfCategories <= 0) {
      this.isCategory = false;
      this.noOfCategories = null;
    } else {
      this.isCategory = true;
    }
  }


  // ****************No of variantRows***************//
  variantCount: number | null = null;

  variantData: { variant: string; name: string }[] = [];
  updateVariantRows(): void {
    if (this.variantCount && this.variantCount > 0) {
      this.variantData = Array.from({ length: this.variantCount }, () => ({
        variant: '',
        name: ''
      }));
    } else {
      this.variantData = [];
    }
  }

  // Validation for tables
  errorsForTable: any = [];
  validateTables(): boolean {
    this.errorsForTable = []; // reset errors

    // 1. Zone validation
    if (this.noOfPricingAreas > 0) {
      this.pricingAreaRows.forEach((row, idx) => {
        if (!row.name?.trim()) {
          this.errorsForTable.push(`Zone row ${idx + 1}: Name is required`);
        }
        if (!row.selectedProvinces || row.selectedProvinces.length === 0) {
          this.errorsForTable.push(`Zone row ${idx + 1}: At least one province is required`);
        }
      });
    }

    // 2. Tier validation
    if (this.noOfTiered > 0) {
      this.tieredRows.forEach((row, idx) => {
        if (!row.name?.trim()) {
          this.errorsForTable.push(`Tier row ${idx + 1}: Name is required`);
        }
      });
    }

    // 3. Variant validation
    if (this.noOfVariants > 0) {
      this.variantRows.forEach((row, idx) => {
        if (!row.name?.trim()) {
          this.errorsForTable.push(`Variant row ${idx + 1}: Name is required`);
        }
      });
    }

    // 4. Category validation
    if (this.noOfCategories > 0) {
      this.categoryRows.forEach((row, idx) => {
        if (!row.name?.trim()) {
          this.errorsForTable.push(`Category row ${idx + 1}: Name is required`);
        }
      });
    }

    // 5. Age band validation
    if (this.ageBands.length > 0) {
      this.ageBands.forEach((row, idx) => {
        if (row.start == null) {
          this.errorsForTable.push(`Age Band row ${idx + 1}: Start is required`);
        }
        if (row.end == null) {
          this.errorsForTable.push(`Age Band row ${idx + 1}: End is required`);
        }
      });
    }

    return this.errorsForTable.length === 0; // ✅ true if valid, false if errors exist
  }

  // **********************Pricing Data Section*****************************//

  selectedZone = false;
  selectedTier = false;
  selectedAge = false;
  selectedVariant = false;
  selectedCategory = false;

  showPricingTable = false;
  showTableType: string = '';

  // Pricing matrix for all possible combinations
  pricingMatrix: {
    [zone: string]: any;
  } = {};

  // For simpler tables (zone -> item only, for example)
  flatPricingMatrix: any = {};
  seeTable : boolean = false;
  showTable(): void {
    if (!this.validateTables()) {
      console.log("❌ Validation failed", this.errorsForTable);
      return;
    }
    this.updateSelectedFlags();
    this.initializePricingMatrix();
    this.showPricingTable = true;
    this.seeTable = true;
    setTimeout(()=>{
      this.seeTable = false;
    },4000)
  }

  updateSelectedFlags(): void {
    this.selectedZone = this.pricingAreaRows.length > 0;
    this.selectedTier = this.tieredRows.length > 0;
    this.selectedAge = this.ageBands.length > 0;
    this.selectedVariant = this.variantRows.length > 0;
    this.selectedCategory = this.categoryRows.length > 0;

    this.resolveTableFormat();
  }

  advisorCommission: number = null;
  tpaCommission: number = null;
  otherFees: number = null;
  unitPrice: number = null;

  resolveTableFormat(): void {
    const z = this.selectedZone;
    const t = this.selectedTier;
    const a = this.selectedAge;
    const v = this.selectedVariant;
    const c = this.selectedCategory;

    // ==> update - dfine array --> fill the validation details
    // forloop

    if (z && t && a && v && c) this.showTableType = 'zone-tier-age-variant-category';
    else if (z && t && a && v) this.showTableType = 'zone-tier-age-variant';
    else if (z && t && a && c) this.showTableType = 'zone-tier-age-category';
    else if (z && t && v && c) this.showTableType = 'zone-tier-variant-category';
    else if (z && a && v && c) this.showTableType = 'zone-age-variant-category';
    else if (t && a && v && c) this.showTableType = 'tier-age-variant-category';
    else if (z && t && a) this.showTableType = 'zone-tier-age';
    else if (z && a && v) this.showTableType = 'zone-age-variant';
    else if (z && a && c) this.showTableType = 'zone-age-category';
    else if (z && t && v) this.showTableType = 'zone-tier-variant';
    else if (z && t && c) this.showTableType = 'zone-tier-category';
    else if (t && a && c) this.showTableType = 'tier-age-category';
    else if (t && v && c) this.showTableType = 'tier-variant-category';
    else if (z && v && c) this.showTableType = 'zone-variant-category';
    else if (t && c) this.showTableType = 'tier-category';
    else if (t && v) this.showTableType = 'tier-variant';
    else if (v && c) this.showTableType = 'variant-category';
    else if (z && t) this.showTableType = 'zone-tier';
    else if (z && v) this.showTableType = 'zone-variant';
    else if (z && c) this.showTableType = 'zone-category';
    else if (t && a) this.showTableType = 'tier-age';
    else if (z && a) this.showTableType = 'zone-age';
    else if (a && c) this.showTableType = 'age-category';
    else if (z) this.showTableType = 'zone-only';
    else this.showTableType = 'default';
  }

  initializePricingMatrix(): void {
    const zRows = this.pricingAreaRows.map(z => z.name || 'default');
    const tRows = this.tieredRows.map(t => t.name || 'default');
    const aRows = this.ageBands.map(a => `${a.start}-${a.end}` || 'default');
    const vRows = this.variantRows.map(v => v.name || 'default');
    const cRows = this.categoryRows.map(c => c.name || 'default');

    for (const z of zRows.length ? zRows : ['default']) {
      for (const t of tRows.length ? tRows : ['default']) {
        for (const a of aRows.length ? aRows : ['default']) {
          for (const v of vRows.length ? vRows : ['default']) {
            for (const c of cRows.length ? cRows : ['default']) {
              this.initializePricingPath(z, t, a, v, c);
            }
          }
        }
      }
    }
  }

  advisorCommissionType: string = "";
  tpaCommissionType: string = "";
  otherFeesType: string = "";
  unitPriceType: string = "";


  initializePricingPath(...keys: string[]) {
    let ref = this.pricingMatrix;
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i] && keys[i].trim() !== '' ? keys[i] : 'default';

      if (!ref[key]) {
        ref[key] = i === keys.length - 1
          ? {
            'Unit Price': 0,
            'Advisor Commission': 0,
            'TPA Commission': 0,
            'Other Fees': 0
          }
          : {};
      } else if (i === keys.length - 1 && typeof ref[key] === 'object') {
        // If object already exists, patch missing fields (in case of partial data)
        ref[key] = {
          'Unit Price': (() => {
            const prevValue = ref[key]['Unit Price'] ?? 0;
            const inputValue = this.unitPrice;
            const type = this.unitPriceType;

            const valueToUse = inputValue !== null && inputValue !== undefined
              ? inputValue
              : prevValue;

            if (type === '%') return `${valueToUse}%`;
            if (type === '$') return `$${valueToUse}`;
            return valueToUse;
          })(),

          'Advisor Commission': (() => {
            const prevValue = ref[key]['Advisor Commission'] ?? 0;
            const inputValue = this.advisorCommission;
            const type = this.advisorCommissionType;

            const valueToUse = inputValue !== null && inputValue !== undefined
              ? inputValue
              : prevValue;

            if (type === '%') return `${valueToUse}%`;
            if (type === '$') return `$${valueToUse}`;
            return valueToUse;
          })(),

          'TPA Commission': (() => {
            const prevValue = ref[key]['TPA Commission'] ?? 0;
            const inputValue = this.tpaCommission;
            const type = this.tpaCommissionType;

            const valueToUse = inputValue !== null && inputValue !== undefined
              ? inputValue
              : prevValue;

            if (type === '%') return `${valueToUse}%`;
            if (type === '$') return `$${valueToUse}`;
            return valueToUse;
          })(),

          'Other Fees': (() => {
            const prevValue = ref[key]['Other Fees'] ?? 0;
            const inputValue = this.otherFees;
            const type = this.otherFeesType;

            const valueToUse = inputValue !== null && inputValue !== undefined
              ? inputValue
              : prevValue;

            if (type === '%') return `${valueToUse}%`;
            if (type === '$') return `$${valueToUse}`;
            return valueToUse;
          })(),
        };


      }

      ref = ref[key];
    }
  }


  getPricingValue(
    zone: string,
    tier: string,
    age: string,
    variant: string,
    category: string,
    field: keyof PricingDetails
  ): number {
    try {
      return (
        this.pricingMatrix?.[zone || 'default']
        ?.[(tier || 'default')]
        ?.[(age || 'default')]
        ?.[(variant || 'default')]
        ?.[(category || 'default')]
        ?.[field] ?? 0
      );
    } catch {
      return 0;
    }
  }

  allowCurrencyOrPercent(event: KeyboardEvent, value: string) {
    const key = event.key;
    const cursor = (event.target as HTMLInputElement).selectionStart ?? 0;

    // allow control/navigation keys
    const allowedKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
    ];
    if (allowedKeys.includes(key)) {
      // block deleting $/% symbols
      if ((key === 'Backspace' && (value[cursor - 1] === '$' || value[cursor - 1] === '%')) ||
        (key === 'Delete' && (value[cursor] === '$' || value[cursor] === '%'))) {
        event.preventDefault();
      }
      return;
    }

    // allow only digits
    if (!/^\d$/.test(key)) {
      event.preventDefault();
      return;
    }

    // enforce placement rules
    if (value.startsWith('$') && cursor === 0) {
      // can't type before $
      event.preventDefault();
    }
    if (value.endsWith('%') && cursor > value.length - 1) {
      // can't type after %
      event.preventDefault();
    }
  }

  preventInvalidPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pasteData = event.clipboardData?.getData('text') || '';
    const digits = pasteData.replace(/\D/g, ''); // keep only digits
    const input = event.target as HTMLInputElement;
    const value = input.value;

    // enforce placement
    let cursor = input.selectionStart ?? 0;
    if (value.startsWith('$') && cursor === 0) cursor = 1;
    if (value.endsWith('%') && cursor >= value.length) cursor = value.length - 1;

    const newValue = value.slice(0, cursor) + digits + value.slice(cursor);
    input.value = newValue;
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }




  setPricingValue(
    zone: string,
    tier: string,
    age: string,
    variant: string,
    category: string,
    field: keyof PricingDetails,
    value: number
  ): void {
    const keys = [zone, tier, age, variant, category].map(k => k || 'default');

    let ref = this.pricingMatrix;
    for (const key of keys) {
      if (!ref[key]) ref[key] = {};
      ref = ref[key];
    }

    ref[field] = value;
  }


  //flat pricing data which we wanted into proper formate
  // logFlatPricing() {
  //   const flatArray = [];

  //   const walk = (obj: any, path: string[] = []) => {
  //     for (const key in obj) {
  //       const value = obj[key];

  //       // If it's a nested object, go deeper
  //       if (typeof value === 'object' && !('Unit Price' in value)) {
  //         walk(value, [...path, key]);
  //       } else {
  //         // We've reached the pricing object
  //         const [zone, tier, ageBand, variant, category] = path;

  //         flatArray.push({
  //           zone: zone === 'default' ? false : zone,
  //           tier: tier === 'default' ? false : tier,
  //           ageBand: ageBand === 'default' ? false : ageBand,
  //           variant: variant === 'default' ? false : variant,
  //           category: category === 'default' ? false : category,
  //           unitPrice: value['Unit Price'],
  //           advisorCommission: value['Advisor Commission'],
  //           tpaCommission: value['TPA Commission'],
  //           otherFees: value['Other Fees']
  //         });
  //       }
  //     }
  //   };

  //   walk(this.pricingMatrix);
  //   return flatArray
  // }



  //*******************************SignUp Form Section*****************************************//
  rows = [
    {
      fields: [
        { fieldName: '', value: '', rule: '' },
        { fieldName: '', value: '', rule: '' },
        { fieldName: '', value: '', rule: '' }
      ]
    }
  ];
  isSavedOnce = false;
  buttonLabel = 'Save';

  addRow() {
    this.rows.push({
      fields: [
        { fieldName: '', value: '', rule: '' },
        { fieldName: '', value: '', rule: '' },
        { fieldName: '', value: '', rule: '' }
      ]
    });
  }
  onFieldChange(): void {
    if (!this.isAllFieldsFilled()) {
      this.isSelfBilling = false;
    }
  }

  //validation of next section
  isAllFieldsFilled(): boolean {
    return this.rows.every(row =>
      row.fields.every(field =>
        field.fieldName.trim() !== '' &&
        field.value.trim() !== '' &&
        field.rule.trim() !== ''
      )
    );
  }


  removeRow(index: number) {
    this.rows.splice(index, 1);
    this.isSelfBilling = false;
  }

  saveOrUpdate() {
    if (!this.isSavedOnce) {
      this.buttonLabel = 'Saving...';
      setTimeout(() => {
        this.buttonLabel = 'Saved';
        this.isSavedOnce = true;
        setTimeout(() => {
          this.buttonLabel = 'Update';
        }, 500);
      }, 1000);
    } else {
      this.buttonLabel = 'Updating...';
      setTimeout(() => {
        this.buttonLabel = 'Updated';
        setTimeout(() => {
          this.buttonLabel = 'Update';
        }, 500);
      }, 1000);
    }
  }



  // *********************************Quil Editor************************************//
  editorContent: string = '';
  editorContentForProductResource: string = '';

  safeHtmlContent: SafeHtml = '';
  safeHtmlContentForProduct_Resource: SafeHtml = '';
  quillModulesForProductResource = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }],
      [{ size: ['12px', '14px', '16px', '18px', '20px', '22px', '24px'] }],
      [{ header: [false, 1, 2, 3, 4, 5, 6] }],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ['clean'],
      ['link']
    ]
  };
  quillModulesForTileDescription = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }],
      [{ size: ['12px', '14px', '16px', '18px', '20px', '22px', '24px'] }],
      [{ header: [false, 1, 2, 3, 4, 5, 6] }],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ['clean'],
      ['link']
    ]
  };

  showTileQuillEditor: boolean = false;
  previewQuillEditor: boolean = false;
  showProduct_Resource_QuillEditor: boolean = false;
  previewProduct_Resource_QuillEditor: boolean = false;



  onViewTileDescription() {
    this.safeHtmlContent = this.sanitizer.bypassSecurityTrustHtml(this.tileDescriptionSavedContent);
    this.previewQuillEditor = true;
  }
  onViewProduct_Resource_Description() {
    this.safeHtmlContentForProduct_Resource = this.sanitizer.bypassSecurityTrustHtml(this.productResourceSavedContent);
    this.previewProduct_Resource_QuillEditor = true;
  }

  onClosePopup() {
    this.previewQuillEditor = false;
  }
  onProductPreviewClosePopup() {
    this.previewProduct_Resource_QuillEditor = false;
  }

  // *********************************Provisioning and Reporting**********************************
  isProvisioning: boolean = null;
  provisioningUrl: string = null;
  provisioningUsername: string = null;
  provisioningPassword: string = null;
  isReporting: boolean = null;
  is2FA: boolean = null;
  isCensus: boolean = null;


  selectedReportingFileTypes: any[] = [];
  // months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  reportingFileTypes = [
    { id: 1, name: 'Excel' },
    { id: 2, name: 'PDF' },
    { id: 3, name: 'CSV' }];

  // reportingFileTypeDropdownSettings = {
  //   singleSelection: false,
  //   idField: 'id',
  //   textField: 'name',
  //   itemsShowLimit: 1,
  //   selectAllText: 'Select All',
  //   unSelectAllText: 'Unselect All',
  //   enableCheckAll: true,
  //   allowSearchFilter: true,
  // };
  frequencyDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    itemsShowLimit: 2,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    enableCheckAll: true,
    allowSearchFilter: true,
  };
  fileTypeDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    itemsShowLimit: 2,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    enableCheckAll: true,
    allowSearchFilter: true,
  };

  isSelfBilling: boolean = null;
  selectedSelfBillingFields: any[] = [];
  selfBillingFields: any[] = [];
  selfBillingDropdownSettings = {
    singleSelection: false,
    idField: 'fieldName',
    textField: 'fieldName',
    itemsShowLimit: 1,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    enableCheckAll: true,
    allowSearchFilter: true,
  };
  censusDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    itemsShowLimit: 1,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    enableCheckAll: true,
    allowSearchFilter: true,
  };


  onProvisioningSelfBilling() {
    const fieldNames = this.rows.flatMap(obj =>
      obj.fields.map(field => field.fieldName)
    );

    // Convert string array to array of objects with fieldName property
    this.selfBillingFields = fieldNames.map(name => ({ fieldName: name }));

    console.log("signup form data:", this.selfBillingFields);

    this.isSelfBilling = true;
  }
  selectedStartMonth: any[] = [];
  selectedEndMonth: any[] = [];

  reportingPeriodDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'name',
    allowSearchFilter: false,
    closeDropDownOnSelection: true
  };

  // ************Census**********************
  customerFields = [
    { id: 1, name: 'Customer ID' },
    { id: 2, name: 'First Name' },
    { id: 3, name: 'Last Name' },
    { id: 4, name: 'Phone Number' },
    { id: 5, name: 'Province' },
    { id: 6, name: 'Status' },
    { id: 7, name: 'Plan Start Date' },
    { id: 8, name: 'Plan Termination Date' }
  ];
  selectedCensusFields: any[] = [];
  isSelfBillingAndCensusEnabled: boolean = null
  isMaintainHistoryForCensusReporting: boolean = null;

  // Provisioning and Reporting
  getPayload() {
    return {
      provisioning: {
        enabled: this.isProvisioning,
        interfaces: {
          web: {
            enabled: this.useWebInterface,
            sandboxAvailable: this.hasSandbox,
            prod: { ...this.prod },
            sandbox: this.hasSandbox ? { ...this.sandbox } : null,
            fields: [...this.webFields],
          },
          api: {
            enabled: this.useAPI,
            apiKey: this.apiKey,
            fields: [...this.apiFields],
          },
        },
      },
      reporting: {
        enabled: this.isReporting,
        fileType: this.reportFileType,
        frequency: this.reportFrequency,
        dueDay: this.dueDate,
        selfBilling: {
          enabled: this.isSelfBilling,
          startMonth: this.startMonth,
          endMonth: this.endMonth,
          fields: [...this.selfFields],
        },
        census: {
          enabled: this.isCensus,
          fields: [...this.censusFields],
        },
        combineReports: this.combineReports,
        maintainHistory: this.maintainHistory,
        compileMode: this.compileMode,
        delivery: {
          method: this.deliveryMethod,
          emailRecipients: this.deliveryMethod[0].name === 'email' ? this.emailRecipients : null,
          sftpHost: this.deliveryMethod[0].name === 'SFTP / Website' ? this.sftpHost : null,
          sftpPath: this.deliveryMethod[0].name === 'SFTP / Website' ? this.sftpPath : null,
        },
      },
    };
  }


  // ******************************** Vendor Address ******************************************
  streetAddress: string = null;
  streetAddress2: string = null;
  selectedCountry = [{ id: 1, name: 'Canada' }];
  productCurrency: any = [{ id: 1, name: 'CAD' }];

  unitNumber: string = null;
  city: string = null;
  country: string = null;
  selectedProvince: any = null;
  postalCode: string = null;

  onPaymentOptionChange(selectedValue: string) {
    this.paymentOption = selectedValue;
    // validate expected payment date
    this.bank_code = null;
    this.transit = null;
    this.account_number = null;
    this.errors.bankCode = null;
    this.errors.transit = null;
    this.errors.accountNumber = null;
    this.errors.expectedPaymentDate = null;
    this.expected_Payment_Date = null;
  }

  // VALIDATION FOR ENTIRE SUPPLIER
  // Errors
  // -------------------------
  errors: any = {};

  // -------------------------
  // Validate single field in real-time
  // -------------------------
  validateField(fieldName: string, value: any) {
    switch (fieldName) {
      case 'supplierName':
        if (!ValidationUtils.isRequired(value)) this.errors.supplierName = ValidationUtils.ERROR_MESSAGES['required'];
        else if (!ValidationUtils.minLength(value, 2)) this.errors.supplierName = ValidationUtils.ERROR_MESSAGES['minLength'];
        else delete this.errors.supplierName;
        break;

      case 'billingType':
        if (!ValidationUtils.isRequired(value)) this.errors.billingType = ValidationUtils.ERROR_MESSAGES['required'];
        else if (!ValidationUtils.minLength(value, 2)) this.errors.billingType = ValidationUtils.ERROR_MESSAGES['minLength'];
        else delete this.errors.billingType;
        break;

      case 'bank_code':
        if (!ValidationUtils.isRequired(value)) this.errors.bankCode = ValidationUtils.ERROR_MESSAGES['required'];
        else if (!ValidationUtils.isNumeric(value.toString()) || value.toString().length !== 3) this.errors.bankCode = 'Bank code must be 3 digits';
        else delete this.errors.bankCode;
        break;


      case 'transit':
        if (!ValidationUtils.isRequired(value)) this.errors.transit = ValidationUtils.ERROR_MESSAGES['required'];
        else if (!ValidationUtils.isNumeric(value.toString()) || value.toString().length !== 5)
          this.errors.transit = 'Transit must be 5 digits';
        else delete this.errors.transit;

        break;

      case 'account_number':
        if (!ValidationUtils.isRequired(value)) this.errors.accountNumber = ValidationUtils.ERROR_MESSAGES['required'];
        else if (!ValidationUtils.isNumeric(value.toString()) || value.toString().length < 7 || value.toString().length > 12)
          this.errors.accountNumber = 'Account must be 7-12 digits';
        else delete this.errors.accountNumber;
        break;

      // case 'account_number':
      //   const regex = /^\d{5}-\d{3}-\d{7,12}$/;
      //   // Format: 12345-001-1234567
      //   if (!ValidationUtils.isRequired(value)) {
      //     this.errors.accountNumber = ValidationUtils.ERROR_MESSAGES['required'];
      //   }
      //   else if (!regex.test(value.toString())) {
      //     this.errors.accountNumber = 'Format must be XXXXX-XXX-XXXXXXX (Transit-Institution-Account)';
      //   }
      //   else {
      //     delete this.errors.accountNumber;
      //   }
      //   break;


      case 'expected_Payment_Date':
        if (!ValidationUtils.isRequired(value)) this.errors.expectedPaymentDate = ValidationUtils.ERROR_MESSAGES['required'];
        else if (!ValidationUtils.isFutureDate(value.toString())) this.errors.expectedPaymentDate = ValidationUtils.ERROR_MESSAGES['futureDate'];
        else delete this.errors.expectedPaymentDate;
        break;

      case 'streetAddress':
        if (!ValidationUtils.isRequired(value)) this.errors.streetAddress = ValidationUtils.ERROR_MESSAGES['required'];
        else delete this.errors.streetAddress;
        break;

      case 'unitNumber':
        if (value && !ValidationUtils.isAlphanumeric(value)) this.errors.unitNumber = ValidationUtils.ERROR_MESSAGES['alphanumeric'];
        else delete this.errors.unitNumber;
        break;

      case 'city':
        if (!ValidationUtils.isRequired(value)) this.errors.city = ValidationUtils.ERROR_MESSAGES['required'];
        else delete this.errors.city;
        break;

      case 'selectedProvince':
        if (!Array.isArray(this.selectedProvince) || this.selectedProvince.length === 0 || !this.selectedProvince[0].shortName?.trim()) {
          this.errors.selectedProvince = ValidationUtils.ERROR_MESSAGES['required'];
        } else {
          delete this.errors.selectedProvince;
        }
        break;


      case 'postalCode':
        const valueTrimmed = value ? value.trim() : '';
        if (!ValidationUtils.isRequired(valueTrimmed)) {
          this.errors.postalCode = ValidationUtils.ERROR_MESSAGES['required'];
        } else if (!ValidationUtils.isPostalCode(valueTrimmed)) {
          this.errors.postalCode = ValidationUtils.ERROR_MESSAGES['postalCode'];
        } else {
          delete this.errors.postalCode;
        }
        break;

    }
  }

  get isFormValid(): boolean {
    // validateAll() should return true only if all required fields are valid
    return this.validateAll();
  }
  // -------------------------
  // Validate all on submit
  // -------------------------
  validateAll() {

    console.log("abcdsfdsfdsfdsfdsfdsfdsfdsfdsf:", this.selectedProvince)

    this.validateField('supplierName', this.supplierName);
    this.validateField('billingType', this.billingType);

    if (this.paymentOption === 'EFT to Vendor') {
      this.validateField('bank_code', this.bank_code);
      this.validateField('transit', this.transit);
      this.validateField('account_number', this.account_number);
    } else {
      this.validateField('expected_Payment_Date', this.expected_Payment_Date);
    }
    this.validateField('streetAddress', this.streetAddress);
    this.validateField('unitNumber', this.unitNumber);
    this.validateField('city', this.city);

    this.validateField('selectedProvince', this.selectedProvince);
    this.validateField('postalCode', this.postalCode);

    // remove keys which has null values
    Object.keys(this.errors).forEach(key => {
      if (this.errors[key] === null) {
        delete this.errors[key];
      }
    });

    return Object.keys(this.errors).length === 0;

  }
  // ****************************** Delete Product ****************************************
  deleteProduct(productId: string): void {
    this.products = this.products.filter(product =>
      product.productInfo?.productId !== productId
    );
  }
  validateCountry() {
    if (!Array.isArray(this.selectedCountry) || this.selectedCountry.length === 0 || !this.selectedCountry[0].name?.trim()) {
      this.errors.country = ValidationUtils.ERROR_MESSAGES['required'];
    } else {
      delete this.errors.country;
    }
  }
  validateProductCurrency() {
    if (!Array.isArray(this.productCurrency) || this.productCurrency.length === 0 || !this.productCurrency[0].name?.trim()) {
      this.errors.pcurrency = ValidationUtils.ERROR_MESSAGES['required'];
    } else {
      delete this.errors.pcurrency;
    }
  }
  // **********************Logging data at console*************************
  LogAllData(): void {
    const logData = {
      // supplier info
      supplierID: this.supplierID,
      supplierName: this.supplierName,
      //contact info
      contactInformations: this.contacts,
      // Product Info
      product_ID: this.product_ID,
      product_name: this.product_name,
      effective_Distribution_Date: this.effective_Distribution_Date,
      product_country: this.product_country,
      selectedProvinces: this.selectedProvinces,

      // Limits
      age_: this.age_,
      minAge: this.minAge,
      maxAge: this.maxAge,
      childAgeOut: this.childAgeOut,
      studentAgeOut: this.studentAgeOut,
      isCOB: this.isCOB,
      renewalDate: this.renewalDate,

      // Product Details
      bookletFileName: this.bookletFileName,
      selectedFileName: this.selectedFileName,
      tileFileName: this.tileFileName,

      // Vendor Invoicing and Payment
      billingType: this.billingType,
      bank_code: this.bank_code,
      transit: this.transit,
      account_number: this.account_number,

      // Pricing Section
      isBaseAmount: this.isBaseAmount,
      taxApplicable: this.taxApplicable,
      taxTypes: this.taxTypes,
      inclusiveTax: this.inclusiveTax,

      // Pricing Areas
      noOfPricingAreas: this.noOfPricingAreas,
      pricingAreaRows: this.pricingAreaRows,

      // Tiers
      isTiered: this.isTiered,
      noOfTiered: this.noOfTiered,
      tieredRows: this.tieredRows,

      // Service Level
      isCategory: this.isCategory,
      noOfCategories: this.noOfCategories,
      categoryRows: this.categoryRows,

      // Age Banding
      isAgeBanded: this.isAgeBanded,
      noOfAgeBands: this.noOfAgeBands,
      ageBands: this.ageBands,
      isVariantEnabled: this.isVariantEnabled,
      noOfVariants: this.noOfVariants,
      variantRows: this.variantRows,
      selectedBaseUnit: this.selectedBaseUnit,

      // Pricing Matrix
      pricingMatrix: PricingMatrixHelper.transform(this.pricingMatrix),

      // Additional Output
      areaWiseAgeBandPricing: this.pricingAreaRows,
      signUpFormData: this.rows
      // Uncomment if needed:
      // province: this.province,
      // areaWiseVariantPricing: this.areaWiseVariantPricing,
    };

    console.log("Logged Data Object:", logData);
  }

  LogAllDataForConsole(): void {
    // Product Info
    console.log('Product ID:', this.product_ID);
    console.log('Product Name:', this.product_name);
    console.log('Supplier ID:', this.supplierID);
    console.log('Eff Dist Date:', this.effective_Distribution_Date);
    console.log('Dist Country:', this.product_country);
    console.log('Distribution Provinces:', this.selectedProvinces);

    // Limits
    console.log('Age Limited:', this.age_);
    console.log('Age Limited Min-Age:', this.minAge);
    console.log('Age Limited Max-Age:', this.maxAge);
    console.log('Age Limited childAgeOut:', this.childAgeOut);
    console.log('Age Limited studentAgeOut:', this.studentAgeOut);
    console.log('COB Rules Apply:', this.isCOB);
    console.log('Renewal Date:', this.renewalDate);

    // Product Details
    console.log('Booklet File:', this.bookletFileName);
    console.log('Product Resource Info File:', this.selectedFileName);
    console.log('Tile Description File:', this.tileFileName);

    // Vendor Invoicing and Payment
    console.log('Billing Type:', this.billingType); // 'Self Billing' or 'Invoiced'
    console.log('Bank Code:', this.bank_code);
    console.log('Transit:', this.transit);
    console.log('Account Number:', this.account_number);

    // Pricing Section
    console.log('Are taxes applicable?:', this.taxApplicable);
    console.log("taxTypes :", this.taxTypes)

    console.log('Is price inclusive of tax?:', this.inclusiveTax);


    // Pricing Areas
    console.log('Number of Pricing Areas:', this.noOfPricingAreas);
    console.log('Pricing Area Rows:', this.pricingAreaRows);

    // Tiers
    console.log('Tiers Enabled:', this.isTiered);
    console.log('Number of Tiers:', this.noOfTiered);
    console.log('Tiers Data:', this.tieredRows);

    // Service Level
    console.log('Service Level Enabled:', this.isCategory);
    console.log('Number of Service Levels:', this.noOfCategories);
    console.log('Service Levels Data:', this.categoryRows);

    // Age Banding
    console.log('Is Age Band enable:', this.isAgeBanded);
    console.log('Number of Age Bands:', this.noOfAgeBands);
    console.log('Age Band Data:', this.ageBands);
    console.log('Is Variant enable:', this.isVariantEnabled);
    console.log('Number of Variants:', this.noOfVariants);
    console.log('Variant Rows:', this.variantRows);
    console.log('Base Unit Value:', this.selectedBaseUnit);

    // Pricing Matrix
    console.log('Pricing Matrix:', this.pricingMatrix);
    // console.log('logFlatPricing :', this.logFlatPricing());
    console.log("Final Pricing table input values :", PricingMatrixHelper.transform(this.pricingMatrix))

    // Additional Pricing Output (Optional)
    console.log('Area-wise Age Band Pricing:', this.pricingAreaRows);

    // Singup form value
    // console.log('Pricing Zone Area Matrix:', this.province);
    // console.log('Area-wise Variant Pricing Final Output:', this.areaWiseVariantPricing);
  }

  states: any[] = [];
  countryId = 1; // example country ID
  apiUrl = `${environment.apiUrl}`;

  // getStatesByCountryId() {
  //   // this.http.get(`${this.apiUrl}/api/ap/countries/${this.countryId}/states-and-provinces`)
  //   //   .subscribe((res: any) => {
  //   //     this.provinces = res;
  //   //     console.log("prssssssssssss:", this.provinces)
  //   //   });
  //   this.http.get(`${this.apiUrl}/api/ap/partners`)
  //     .subscribe((res: any) => {
  //       // this.provinces = res;
  //       // console.log("prssssssssssss:", this.provinces)
  //       console.log("partners data :", res)
  //     });
  // }
  ngOnInit(): void {
    this.getLanguageTokens(); // Load language on init
    // this.getStatesByCountryId();
    console.log("SupplierID:", this.supplierID);
    this.editor = new Editor({
      history: true,
      keyboardShortcuts: true,
      inputRules: true,
    }); // Create Tile editor on page load
    this.product_resource_editor = new Editor({
      history: true,
      keyboardShortcuts: true,
      inputRules: true,
    }); // Create product resouce info

    // VALIDATION FOR CONTACT FORM
    this.contactForm = this.formBuilder.group({
      firstName: ['', RxwebValidators['required']()],
      lastName: ['', RxwebValidators['required']()],
      email: ['', [RxwebValidators['required'](), RxwebValidators.email()]],
      phone: [
        '',
        [
          RxwebValidators['required'](),
          RxwebValidators.pattern({ expression: { exactTen: /^.{10}$/ } })
        ]
      ]
      ,
      role: ['', RxwebValidators['required']()],
      contact_other: ['']
    });

    var signinResults = JSON.parse(sessionStorage.getItem('signinResults'));
    this.username = signinResults?.userInfo?.name;
    this.user_role = signinResults?.userInfo.role;
    console.log("this.supplierData ..................... :",this.supplierData)
    this.callFunctionForUpdateSupplier()
    // this.portalInfo = signinResults?.portalInfo;
  }

  // ************************************* Signup sheet ************************************
  showPopups = false;

  fieldTypes = [
    { id: 1, name: 'Text' },
    { id: 2, name: 'Email field' },
    { id: 3, name: 'Phone field' },
    { id: 4, name: 'Number' },
    { id: 5, name: 'Date picker' },
    { id: 6, name: 'Dropdown' },
    { id: 7, name: 'Radio button' },
    { id: 8, name: 'Checkbox' },
    { id: 9, name: 'File upload' },
    { id: 10, name: 'Signature pad' }
  ];
  fieldName = '';
  fieldRules = '';

  fields: any[] = [];
  signUpFieldType: string = "";

  tempForSignupSheet: any[] = [];

  // open signup popup
  openPopup() {
    if (this.tempForSignupSheet.length === 0) {
      this.tempForSignupSheet = this.getSignupSheetData()
    }
    this.showPopups = true;
  }
  getActiveCount(): number {
    if (!this.fields.length) {
      return 23
    }
    return this.fields.filter(f => f.active).length;
  }
  addField() {
    if (!this.fieldName || !this.signUpFieldType) return;

    this.tempForSignupSheet.push({
      name: this.fieldName,
      type: this.signUpFieldType,
      rules: this.fieldRules,
      active: true
    });

    this.fieldName = '';
    this.signUpFieldType = '';
    this.fieldRules = '';
  }

  deleteField(index: number) {
    this.tempForSignupSheet.splice(index, 1);
  }

  onCancel() {
    this.getActiveCount();
    this.showPopups = false;
    // Close modal logic
  }
  getSignupSheetData(): Array<{
    name: string;
    type: { id: number; name: string }[];
    rules: string;
    active: boolean;
  }> {
    return [
      { name: 'Plan Enrollment Date', type: [{ id: 5, name: 'Date picker' }], rules: 'required', active: true },
      { name: 'First Name', type: [{ id: 1, name: 'Text' }], rules: 'required', active: true },
      { name: 'Last Name', type: [{ id: 1, name: 'Text' }], rules: 'required', active: true },
      { name: 'Email', type: [{ id: 2, name: 'Email field' }], rules: 'required|email', active: true },
      { name: 'Phone Number', type: [{ id: 3, name: 'Phone field' }], rules: 'required|phone', active: true },
      { name: 'Street Address', type: [{ id: 1, name: 'Text' }], rules: 'required', active: true },
      { name: 'Street Address Line 2', type: [{ id: 1, name: 'Text' }], rules: '', active: true },
      { name: 'Unit/Apt/Suite', type: [{ id: 1, name: 'Text' }], rules: '', active: true },
      { name: 'City', type: [{ id: 1, name: 'Text' }], rules: 'required', active: true },
      { name: 'Province of Residence', type: [{ id: 6, name: 'Dropdown' }], rules: 'required', active: true },
      { name: 'Postal Code', type: [{ id: 1, name: 'Text' }], rules: 'required', active: true },
      { name: 'Province of Employment', type: [{ id: 6, name: 'Dropdown' }], rules: 'required', active: true },
      { name: 'Date of Birth', type: [{ id: 5, name: 'Date picker' }], rules: 'required|date', active: true },
      { name: 'Gender', type: [{ id: 6, name: 'Dropdown' }], rules: 'required', active: true },
      { name: 'Date of Hire', type: [{ id: 5, name: 'Date picker' }], rules: 'required|date', active: true },
      { name: 'Company Name', type: [{ id: 1, name: 'Text' }], rules: 'required', active: true },
      { name: 'Job Title', type: [{ id: 1, name: 'Text' }], rules: 'required', active: true },
      { name: 'Work Eligibility Confirmation', type: [{ id: 7, name: 'Radio button' }], rules: 'required', active: true },
      { name: 'Provincial Health Coverage Confirmation', type: [{ id: 7, name: 'Radio button' }], rules: 'required', active: true },
      { name: 'Spouse Information', type: [{ id: 7, name: 'Radio button' }], rules: 'required', active: true },
      { name: 'Dependent Children Information', type: [{ id: 7, name: 'Radio button' }], rules: 'required', active: true },
      { name: 'Agree to Terms & Conditions', type: [{ id: 8, name: 'Checkbox' }], rules: 'required', active: true },
      { name: 'Advisor Disclosure Agreement', type: [{ id: 8, name: 'Checkbox' }], rules: 'required', active: true }
    ];
  }

  onReset(): void {
    this.tempForSignupSheet = this.getSignupSheetData()
  }
  replaceSaveName: String = "Save"
  numberOfFields: Number = 0;
  onSave() {
    this.replaceSaveName = "Saved"
    this.fields = this.tempForSignupSheet
    this.numberOfFields = this.getActiveCount();
    // this.tempForSignupSheet = this.fields 
    console.log('Signup Final Fields:', this.tempForSignupSheet);
    setTimeout(() => {
      this.showPopups = false;
      this.replaceSaveName = "Save"
    }, 300);
  }
  // **************************Adding Supplier into Database***************************
  username: string = "";
  user_role: string = "";
  showSupplierBackendResponse: boolean = false;

  isSubmitedSupplier: boolean = false;
  onSubmitSupplier(): void {
    this.isSubmitedSupplier = true
    console.log("table price :", this.errors)
    if (!this.isFormValid) {
      return;
    }
    this.contacts = (this.contacts ?? []).map((contact, index) => ({
      ...contact,
      id: contact.id ?? (index + 1)
    }));
    const serviceProvider = {
      billingType: this.billingType,
      paymentOption: this.paymentOption,
      eftToVendor: {
        bankCode: this.bank_code,
        transit: this.transit,
        accountNumber: this.account_number
      },
      expectedPaymentDate: this.expected_Payment_Date,
      productCurrency: this.productCurrency
    };
    const vendorAddress = {
      streetAddress: this.streetAddress,
      streetAddress2: this.streetAddress2,
      selectedCountry: this.selectedCountry,
      unitNumber: this.unitNumber,
      city: this.city,
      country: this.country,
      selectedProvince: this.selectedProvince,
      postalCode: this.postalCode
    }
    const payload = {
      supplierName: this.supplierName.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
      supplierId: this.supplierID,
      products: Array.isArray(this.products) ? this.products : [],
      contactInfo: this.contacts,
      serviceProvider: serviceProvider,
      vendorAddress: vendorAddress,
      catalogVersion: 'v1.0',
      history: [
        {
          action: this.mode === 'update' ? 'Updated' : 'Created',
          by: this.username,
          role: this.user_role,
          at: new Date().toISOString()
        }
      ],
      created: this.mode === 'create' ? new Date().toISOString() : this.supplierData?.created,
      modified: new Date().toISOString()
    };


    console.log("payload :", payload);

    if (this.mode === 'create') {
      const url = `${environment.apiUrl}/api/ap/suppliers`;
      // const url = `http://localhost:3030/api/ap/suppliers`;
      this.http.post(url, payload).subscribe({
        next: (res) => {
          console.log('Supplier created successfully', res);
          this.showSupplierBackendResponse = true;
        },
        error: (err) => {
          console.error('Error creating supplier', err);
        }
      });

    }
    if (this.mode === 'update') {
      // const url = `http://localhost:3030/api/ap/suppliers/${this.supplierData.id}`;
      const url = `${environment.apiUrl}/api/ap/suppliers/${this.supplierData.id}`;

      this.http.patch(`${url}`, payload).subscribe({
        next: (res) => {
          this.showSupplierBackendResponse = true;
          console.log('Supplier updated', res);
        },
        error: (err) => {
          console.error('Update failed', err);
        }
      });
    }
  }

  // ***************************************** Edit Supplier Product ******************************
  selectedProduct: any = {};
  editSingleProductModal: boolean = false;
  selectedSupplierId: number = 0;
  editProduct(product: any): void {
    console.log("editProducteditProducteditProducteditProducteditProducteditProducteditProducteditProducteditProducteditProducteditProducteditProducteditProducteditProducteditProduct :", product)
    this.selectedProduct = product;
    this.editSingleProductModal = true;
  }

  onProductUpdated(updated: any) {
    this.products = this.products.map(p =>
      p.productId === updated.productId ? updated : p
    );
    this.editSingleProductModal = false
  }

  ngOnDestroy(): void {
    this.editor.destroy(); // Clean up editor when leaving the page
  }


  // Update Supplier Logic
  supplierData?: any;          // <-- add this line
  mode: 'create' | 'update' = 'create';
  callFunctionForUpdateSupplier(): void {
    // First try getCurrentNavigation, fallback to history.state
    const navigation = this.router.getCurrentNavigation();
    const state = (navigation?.extras.state || history.state) as SupplierState;

    this.supplierData = state?.supplierData || null;
    this.existingSuppliers = state?.alreadyexistingSuppliers
    console.log("existingSuppliers :", this.existingSuppliers)

    this.mode = state?.mode || 'create';

    this.supplierID = this.generateSupplierID();
    console.log("Selected Entire Supplier Data:", state);
    if (this.mode === 'update') {
      this.supplierName = this.supplierData?.supplierName;
      console.log("Selected supplierName:", this.supplierName);
      this.existingSuppliers = this.existingSuppliers.filter(
        supplier => supplier.name.toLowerCase() !== this.supplierName.toLowerCase()
      );

      this.supplierID = this.supplierData?.supplierId;
      console.log("Selected supplierID:", this.supplierID);

      this.contacts = this.supplierData?.contactInfo;
      console.log("Selected contacts Data:", this.contacts);

      
      // Vendor Invoicing and Payment Method 
      console.log("this.supplierData?.serviceProvider :", this.supplierData?.serviceProvider)
      this.billingType = this.supplierData?.serviceProvider?.billingType
      this.expected_Payment_Date = this.supplierData?.serviceProvider?.expectedPaymentDate
      this.account_number = this.supplierData?.serviceProvider?.eftToVendor?.accountNumber
      this.transit = this.supplierData?.serviceProvider?.eftToVendor?.transit
      this.bank_code = this.supplierData?.serviceProvider?.eftToVendor?.bankCode
      this.paymentOption = this.supplierData?.serviceProvider?.paymentOption

      // Vendor Address
      this.streetAddress = this.supplierData?.vendorAddress?.streetAddress
      this.streetAddress2 = this.supplierData?.vendorAddress?.streetAddress2
      this.productCurrency = this.supplierData?.serviceProvider?.productCurrency
      this.selectedCountry = this.supplierData?.vendorAddress?.selectedCountry
      this.unitNumber = this.supplierData?.vendorAddress?.unitNumber
      this.city = this.supplierData?.vendorAddress?.city
      this.country = this.supplierData?.vendorAddress?.country
      this.selectedProvince = this.supplierData?.vendorAddress?.selectedProvince
      this.postalCode = this.supplierData?.vendorAddress?.postalCode

      // Products
      const data = this.supplierData?.products
      console.log("My Product:", data)
      for (const item of data) {
        this.products.push(item);
      }
    }
  }


  // Signup sheet manage
  // Dropdown options
  signupTemplates = [
    { id: 1, text: 'Health & Dental' },
    { id: 2, text: 'Wellness' },
    { id: 3, text: 'Life, CI & AD&D' },
    { id: 4, text: 'LTD & Life' },
    { id: 5, text: 'Life' },
    { id: 6, text: 'New template' }
  ];

  selectedTemplate: any = null;

  // Settings for ng-multiselect-dropdown
  templateDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'text',
    allowSearchFilter: false,
    closeDropDownOnSelection: true,
    enableCheckAll: false,
    clearable: true
  };

  targetsIndividual: boolean = false;
  targetsCorporate: boolean = false;
  isGroupPlan: boolean = false;
  minHeadcount: number | null = 1;

  onTemplateSelect(event: any) {
    this.tempForSignupSheet = event.text !== 'New template' ? this.getSignupSheetData() : []
    this.showPopups = true;
  }

  getSignupPayload() {
    return {
      targets: {
        individual: this.targetsIndividual,
        corporate: this.targetsCorporate,
        isGroupPlan: this.isGroupPlan,
        minHeadcount: this.isGroupPlan ? this.minHeadcount : null
      },
      template: {
        selected: this.selectedTemplate,
        fields: this.fields   // these are saved in onSave()
      }
    };
  }
  // ****************************************** Provisioning and Reporting ********************************************/// 
  // toggles
  // isProvisioning = false;
  useWebInterface = false;
  useAPI = false;
  hasSandbox = false;

  // env data
  prod = { loginUrl: '', username: '', password: '', provisioningUrl: '', is2FA: false };
  sandbox = { loginUrl: '', username: '', password: '', provisioningUrl: '', is2FA: false };

  webFields: any[] = [];
  apiFields: any[] = [];

  apiKey = '';

  // reporting
  // isReporting = false;
  reportFileType :any = 'csv';
  reportFrequency :any =  'Monthly';
  dueDate = null;

  // isSelfBilling = false;
  // isCensus = false;
  startMonth:any = null;
  endMonth :any = null;
  monthList = [
    { name: "January" },
    { name: "February" },
    { name: "March" },
    { name: "April" },
    { name: "May" },
    { name: "June" },
    { name: "July" },
    { name: "August" },
    { name: "September" },
    { name: "October" },
    { name: "November" },
    { name: "December" }
  ];
  months = [
    { id: 1, name: 'January' },
    { id: 2, name: 'February' },
    { id: 3, name: 'March' },
    { id: 4, name: 'April' },
    { id: 5, name: 'May' },
    { id: 6, name: 'June' },
    { id: 7, name: 'July' },
    { id: 8, name: 'August' },
    { id: 9, name: 'September' },
    { id: 10, name: 'October' },
    { id: 11, name: 'November' },
    { id: 12, name: 'December' }
  ];



  selfFields: any[] = [];
  censusFields: any[] = [];

  combineReports = false;
  maintainHistory = false;
  compileMode = [{ id: 'compile', name: 'Compile' }];

  deliveryMethod = [{ id: 'email', name: 'Email' }];
  emailRecipients = '';
  sftpHost = '';
  sftpPath = '';

  // dynamic field management
  addFields(type: string) {
    if (type === 'web') this.webFields.push({ key: '', value: '' });
    if (type === 'api') this.apiFields.push({ key: '', value: '' });
    if (type === 'self') this.selfFields.push({ key: '', value: '' });
    if (type === 'census') this.censusFields.push({ key: '', value: '' });
  }

  removeField(type: string, i: number) {
    if (type === 'web') this.webFields.splice(i, 1);
    if (type === 'api') this.apiFields.splice(i, 1);
    if (type === 'self') this.selfFields.splice(i, 1);
    if (type === 'census') this.censusFields.splice(i, 1);
  }



  // question + akash + george
  // Q1: Yes/No
  hasHealthCard: boolean | null = null;

  // Q2: No. of cards
  numCards: number | null = null;

  fileTypes = ["CSV", "Excel", "PDF"];
  frequencies = ["Monthly", "Quarterly", "Half-yearly", "Yearly"];


  // Q3: Rows (dynamic). Each row stores selected TYPE and SOURCE.
  // For ng-multiselect-dropdown single-select, we bind arrays with 0..1 item.
  cards: Array<{
    type: Array<{ id: string; text: string }>;
    source: Array<{ id: string; text: string }>;
  }> = [];

  // Dropdown options
  cardTypeOptions = [
    { id: 'health', text: 'Health Card' },
    { id: 'certificate', text: 'Certificate' }
  ];

  cardSourceOptions = [
    { id: 'portal', text: 'Through Supplier Portal' },
    { id: 'supplier', text: 'Provided by Supplier' },
    { id: 'system', text: 'Generated by System' }
  ];

  // Single-select settings for ng-multiselect-dropdown (your reference component)
  singleSelectDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'text',
    closeDropDownOnSelection: true,
    allowSearchFilter: false,
    enableCheckAll: false,
    itemsShowLimit: 1
  };

  // Keep your integer-only guard for the number input
  validateInteger(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace',
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'Delete',
      'Home',
      'End'
    ];

    // Allow navigation/control keys
    if (allowedKeys.includes(event.key)) {
      return;
    }

    // Allow only digits (0–9)
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }
  validatePaste(event: ClipboardEvent) {
    const pasteData = event.clipboardData?.getData('text') ?? '';
    if (!/^[0-9]*$/.test(pasteData)) {
      event.preventDefault();
    }
  }



  // Adjust rows whenever numCards changes
  onNumCardsChange(value: number | null) {
    const n = Math.max(0, Number(value || 0));
    // Expand
    while (this.cards.length < n) {
      this.cards.push({ type: [], source: [] });
    }
    // Shrink
    if (this.cards.length > n) {
      this.cards.splice(n);
    }
  }

  // when we need to submit along with pricing data
  getHealthCardsPayload() {
    if (!this.hasHealthCard) {
      return { hasCard: false, cards: [], numCards: null };
    }
    const mapped = this.cards.map(r => ({
      type: r.type || null,
      source: r.source || null
    }));
    return { hasCard: true, cards: mapped, numCards: this.numCards };
  }
}




export interface PricingDetails {
  'Unit Price'?: number;
  'Advisor Commission'?: number;
  'TPA Commission'?: number;
  'Other Fees'?: number;
}


export interface SupplierState {
  supplierData?: any;
  mode?: 'create' | 'update';
  alreadyexistingSuppliers?: any;
}